"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tick = void 0;
var react_1 = __importDefault(require("react"));
var util_1 = require("./util");
var TICK_VERTICAL_DISLOCATION_AXIS_X = 15;
var TICK_VERTICAL_DISLOCATION_AXIS_Y = 5;
function Tick(props) {
    var value = props.payload.value;
    var dy = props.isAxisX ? TICK_VERTICAL_DISLOCATION_AXIS_X : TICK_VERTICAL_DISLOCATION_AXIS_Y;
    return (react_1.default.createElement("text", __assign({ dy: dy }, util_1.convertTickProps(props)), props.isOutlierIndicator ? ">" + props.domainMaxValue : value));
}
exports.Tick = Tick;
//# sourceMappingURL=Tick.js.map